module.exports = __webpack_public_path__ + "static/media/02.fc324f21.jpg";